import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import './index.css';
import isMainshop from '../../mainDealerFilter';

const propTypes = {
  numberOfBuckets: PropTypes.number.isRequired,
  filters: PropTypes.array.isRequired,
  filteredDealersList: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func.isRequired,
};

class DealerFilters extends Component {
  renderFilterBtn = () => {
    const filterButtons = [];
    const { numberOfBuckets, filters, toggleFilter } = this.props;

    for (let i = 0; i < numberOfBuckets; i += 1) {
      const btnClass = classNames('DealerFilters__filter_btn', {
        'DealerFilters__filter_btn--active': filters.indexOf(i) !== -1,
      });

      filterButtons.push(
        <button key={i} className={btnClass} onClick={() => toggleFilter(i)}>
          {i + 1}
        </button>,
      );
    }

    return filterButtons;
  };

  getActiveDealersCount = () => {
    const { filteredDealersList } = this.props;
    return filteredDealersList.filter(d => isMainshop(d.id)).length;
  };

  render() {
    return (
      <div className="DealerFilters">
        <div className="DealerFilters__content">
          <div className="DealerFilters__label">
            <FormattedMessage id="filters" defaultMessage="Filters" />
          </div>
          <div className="DealerFilters__filters_wrapper">{this.renderFilterBtn()}</div>
          <div className="DealerFilters__active_count">
            <FormattedMessage id="dealers_selected" defaultMessage="Selected dealers" />
            <span>: </span>
            <span>{this.getActiveDealersCount()}</span>
          </div>
        </div>
      </div>
    );
  }
}

DealerFilters.propTypes = propTypes;

export default injectIntl(DealerFilters);



// WEBPACK FOOTER //
// ../ui-components/components/DealerFilters/index.jsx